import { defineMessages } from 'react-intl';

const messages: {
	more: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	moreDownIcon: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	pageIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	more: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.more',
		defaultMessage: 'More',
		description: 'Navigation link label for the more dropdown showing custom pages',
	},
	moreDownIcon: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.more.chevron-down',
		defaultMessage: 'Open more dropdown',
		description:
			'Accessible label for the chevron-down icon button in the company hub navbar that opens the More navigation dropdown listing custom pages.',
	},
	pageIconLabel: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.more.page-icon-label',
		defaultMessage: 'Page icon',
		description: 'Label for the page icon in the more dropdown',
	},
});

export default messages;
